import React, { useEffect, useState } from 'react';
import './RegisterForm.css';
import FormDiv from '../Common/FormInput';
import { supabase } from '../../supabase';
import Btn from '../Common/Btn';
import { useNavigate } from 'react-router-dom';


const RegisterForm = () => {

    const navigate = useNavigate();
    const [users, setUsers] = useState([]);


    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        notes: ''
    });

    useEffect(() => {
        const getUsers = async () => {
            const res = await supabase.from('users').select('*');
            if (res.data) setUsers(res.data);
        };
        getUsers();
    }, []);


    

    const handleSubmit = async (e) => {
        e.preventDefault(); 


        const { data: userData, error: userError } = await supabase
            .from('users')
            .insert([
                { 
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    email: formData.email,
                    phone_no: formData.phone 
                }
            ])
            .select(); 

        if (userError) {
            alert("Error creating user: " + userError.message);
            return;
        }


        const newUserId = userData[0].id;

        const { error: bookingError } = await supabase
            .from('bookings')
            .insert([
                {
                    user_id: newUserId,
                    booking_date: formData.date,
                    booking_time: formData.time,
                    additional_notes: formData.notes
                }
            ]);

        if (bookingError) {
            alert("User created, but booking failed: " + bookingError.message);
        } else {
            console.log("Everything saved successfully!");
            navigate('/home');    
        }

    };


    return ( <form className='RForm' onSubmit={handleSubmit}>
        <div className='FormGrid'>
            <FormDiv label="First Name" type="text" placeholder="Enter your first name" onChange={(val) => setFormData({...formData, firstName: val})} />
                <FormDiv label="Last Name" type="text" placeholder="Enter your last name" onChange={(val) => setFormData({...formData, lastName: val})}/>
                <FormDiv label="Email" type="email" placeholder="Enter your email address" onChange={(val) => setFormData({...formData, email: val})} />
                <FormDiv label="Phone Number" type="tel" placeholder="Enter your phone number" onChange={(val) => setFormData({...formData, phone: val})} />
                <FormDiv label="Preferred Date" type="date" onChange={(val) => setFormData({...formData, date: val})}/>
                <FormDiv label="Preferred Time" type="time"  onChange={(val) => setFormData({...formData, time: val})}/>
        </div>

        <div className='FormDiv'>
            <label className='RFormLabel'>Additional Notes</label>
            <textarea className='FormInputArea' placeholder='Any specific questions or requirments' onChange={(e) => setFormData({...formData, notes: e.target.value})}></textarea>
        </div>

        <Btn type='submit' BtnText="Register" BtnPath="" BtnStyle="GreenBtn" />
    </form>
)};
 
export default RegisterForm;